import { gql } from '@apollo/client'

const CREATE_SOP_MUTATION = gql`
  mutation createSop($data: SopInput!) {
    createSop(data: $data) {
      id
      name
      link
    }
  }
`

export default CREATE_SOP_MUTATION
